import {
    SET_PAGE_NAME_SUCCESS,
    SET_PAGE_NAME_FAILED,
    SET_PAGE_NAME
} from './../constants/constants'
import cookie from 'react-cookies'
const initialState = {
    name: ''
}


const PageName = (state = initialState, action) => {

    switch (action.type) {
        case SET_PAGE_NAME:
            return {
                ...state,
            }
        case SET_PAGE_NAME_SUCCESS:
            
            return {
                ...state,
                name: action.data
            }
        case SET_PAGE_NAME_FAILED:

            return {
                ...state,
                name: action.payload
            }
        default:
            return state
    }

}
export default PageName;